export default __webpack_public_path__ + "static/media/Jones_02.511b3fff.jpg";